function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;


// WEBPACK FOOTER //
// ./~/@babel/runtime/helpers/interopRequireDefault.js